var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('body',[_c('logo'),_c('navBar'),_c('flashBanner'),_c('div',{staticClass:"container is-fluid"},[_c('br'),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }